import config from './_config'
import { useMutation } from '../../internal'

const useCreateContract = () => {
  const mutation = useMutation()

  return mutation<never, FormData>({
    method: 'POST',
    endpoint: config?.endpoint,
    contentType: 'multipart'
  })
}

export default useCreateContract
